<div class="canvasContainer" [class.readonly]="readonly">
  <canvas #signature></canvas>
  @if (signaturePad && !readonly) {
    <div class="deleteButton">
      <button mat-icon-button (click)="clear()" [ariaLabel]="'SIGNATURE.BUTTON.CLEAR' | translate">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  }
</div>
